module.exports = __webpack_public_path__ + "img/active_03.54552b3d.jpg";